import React from 'react';
import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { Link } from 'components/Link/Link';

type Props = {
  destinationUrl: string;
  displayText: string;
  refTags: any;
};

export const CustomAhref = ({
  destinationUrl,
  displayText,
  refTags,
}: Props) => {
  return (
    <StyledLink href={destinationUrl} rel={refTags as string}>
      {displayText}
    </StyledLink>
  );
};

const StyledLink = styled(Link)`
  color: ${Colors.blue500};
  font-size: 16px;
  font-weight: 600;
  line-height: 175%;
  ${mediaQueries.desktop} {
    font-size: 19px;
  }
`;
